import { configureStore } from '@reduxjs/toolkit';
import setupInterceptors from '../utils/setupInterceptors';
import rootReducer from './reducers';
import { initializeAuth } from './actions/authActions';
import { SERVER_ERROR_MESSAGE } from './constants/authConstants';
import { thunk } from 'redux-thunk';

const createAppStore = async () => {
  try {
    const store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => [...getDefaultMiddleware({ serializableCheck: false }), thunk],
    });

    // Interceptors must be attached BEFORE any dispatch that triggers an
    // AUTH_API call — otherwise initializeAuth's /me hydrate fires without
    // Authorization header and always 401s.
    setupInterceptors(store);

    await store.dispatch(initializeAuth());

    return store;
  } catch (error) {
    throw new Error(SERVER_ERROR_MESSAGE);
  }
};

export default createAppStore;
